export const WEB = 'WEB';
export const API = 'API';
export const UNKNOWN = 'UNKNOWN';
export const MOBILE = 'MOBILE';
export const INTEGRATOR = 'INTEGRATOR';
export const CRM = 'CRM';
export const SLACK = 'SLACK';